export function isSymptomsComplete(data) {
  return (
    data.painLevel > 1 ||
    (data.moods && data.moods.length > 0) ||
    (data.giSymptoms && data.giSymptoms.length > 0) ||
    data.isFlareDay === true ||
    data.crampIntensity != null
  );
}

export function isMedicationComplete(data) {
  return data.medicationLogs && data.medicationLogs.length > 0;
}

export function isLifestyleComplete(data) {
  return (
    data.stressLevel > 1 ||
    data.exerciseType != null ||
    data.sleepHours != null
  );
}

export function isPeriodComplete(data) {
  return data.isPeriodDay === true || data.isPeriodDay === false;
}

export function isNotesComplete(data) {
  return data.notes && data.notes.trim().length > 0;
}

export function isRecoveryComplete(data) {
  return (
    data.recoverySelfAssessment != null ||
    data.incisionPainLevel != null ||
    data.shoulderGasPainLevel != null ||
    (data.incisionObservations && data.incisionObservations.length > 0) ||
    (data.complications && data.complications.length > 0)
  );
}
